import { useEffect } from "react";
import { useGlobalState } from "utilities/contexts/use-global-state-context";
import GtmEvents from "utilities/enumerations/googleTagManager/GtmEvent";
import GtmLoginStatus from "utilities/enumerations/googleTagManager/GtmLoginStatus";
import RoleType from "utilities/enumerations/role-type";
import TagManager from "react-gtm-module";
import useCurrentIdentity from "../use-current-identity";

export interface TagManagerDataLayer {
    dataLayer: {
        environment?: string;
        event?: string;
        loginStatus?: GtmLoginStatus;
        role?: RoleType;
        nsID?: number;
        webUserID?: number;
    };
}

const useUserInfoInGtm = (): void => {
    const { isAuthenticated, globalState } = useGlobalState();
    const { currentIdentity } = useCurrentIdentity();

    // Updates GTM dataLayer on session change (logged in vs logged out)
    useEffect(() => {
        const sessionDataLayer: TagManagerDataLayer = {
            dataLayer: {
                environment: globalState.getSystemSettings().environmentName,
                event: GtmEvents.Session,
                loginStatus: isAuthenticated
                    ? GtmLoginStatus.LoggedIn
                    : GtmLoginStatus.LoggedOut,
            },
        };
        TagManager.dataLayer(sessionDataLayer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthenticated]);

    // Updates GTM dataLayer on user info update
    useEffect(() => {
        if (isAuthenticated && currentIdentity) {
            const userDataLayer: TagManagerDataLayer = {
                dataLayer: {
                    environment:
                        globalState.getSystemSettings().environmentName,
                    event: GtmEvents.Role,
                    webUserID: currentIdentity.user?.webId,
                    nsID: currentIdentity.user?.netsuiteId,
                    role: currentIdentity.getCurrentUserRole()?.roleId,
                },
            };
            TagManager.dataLayer(userDataLayer);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentIdentity, isAuthenticated]);
};

export default useUserInfoInGtm;
